import React from "react";
import Header from "./../Header";
import Sidebar from "./../Sidebar";
import OrderStatusTemplate from "./OrderStatusTemplate";
import Footer from "./../Footer";
const OrderStatus = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <OrderStatusTemplate />
      <Footer />
    </>
  );
};

export default OrderStatus;
